module.exports = {
  "pageView": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "screen": "string",
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "planBuilderInteraction": {
    "name": "plan-builder-interaction",
    "class": "interaction",
    "properties": {
      "component": "string",
      "action": "string",
      "skuId": {
        "type": "number",
        "isOptional": true
      },
      "productName": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "currency": {
        "type": "string",
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      },
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "selectCurrency": {
    "name": "select-currency",
    "class": "interaction",
    "properties": {
      "currency": "string",
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "termSelectorInteraction": {
    "name": "term-selector-interaction",
    "class": "interaction",
    "properties": {
      "term": "string",
      "action": "string",
      "trackingSource": "string",
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "discountShown": {
        "type": "string",
        "isOptional": true
      },
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "scrollInteraction": {
    "name": "scroll-interaction",
    "class": "interaction",
    "properties": {
      "edition": {
        "type": "string",
        "isOptional": true
      },
      "name": "string",
      "action": "string",
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "additionalUnitsPicker": {
    "name": "additional-units-picker",
    "class": "interaction",
    "properties": {
      "trackingSource": "string",
      "unitType": [
        "CONTACT",
        "MARKETING_CONTACT",
        "USER",
        "UNIT"
      ],
      "productLine": {
        "type": "string",
        "isOptional": true
      },
      "productLevel": {
        "type": "string",
        "isOptional": true
      },
      "productName": {
        "type": "string",
        "isOptional": true
      },
      "ownsProduct": {
        "type": "boolean",
        "isOptional": true
      },
      "skuId": "number",
      "ownedUnitQuantity": "number",
      "displayedUnitQuantity": "number",
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "clickToViewModal": {
    "name": "click-to-view-modal",
    "class": "interaction",
    "properties": {
      "edition": {
        "type": "string",
        "isOptional": true
      },
      "hub": {
        "type": "string",
        "isOptional": true
      },
      "name": "string",
      "feature": {
        "type": "string",
        "isOptional": true
      },
      "productLine": {
        "type": "string",
        "isOptional": true
      },
      "productLevel": {
        "type": "string",
        "isOptional": true
      },
      "location": {
        "type": "string",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "skuIds": {
        "type": "array",
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      },
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "faqInteraction": {
    "name": "faq-interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "questionKey": "string",
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "modalInteraction": {
    "name": "modal-interaction",
    "class": "interaction",
    "properties": {
      "hub": {
        "type": "string",
        "isOptional": true
      },
      "action": "string",
      "modalName": "string",
      "feature": {
        "type": "string",
        "isOptional": true
      },
      "productLevel": {
        "type": "string",
        "isOptional": true
      },
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "externalLinkClick": {
    "name": "external-link-click",
    "class": "interaction",
    "properties": {
      "name": "string",
      "url": {
        "type": "string",
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "internalLinkClick": {
    "name": "internal-link-click",
    "class": "interaction",
    "properties": {
      "name": "string",
      "url": {
        "type": "string",
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "fromTab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "toTab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "bannerInteraction": {
    "name": "banner-interaction",
    "class": "interaction",
    "properties": {
      "name": "string",
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "compareToolInteraction": {
    "name": "compare-tool-interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "added product",
        "removed product",
        "updated product",
        "viewed features",
        "clicked compare button"
      ],
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "product": {
        "type": "string",
        "isOptional": true
      },
      "updatedProduct": {
        "type": "string",
        "isOptional": true
      },
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "featureTableInteraction": {
    "name": "feature-table-interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "clicked-expand-all-sections",
        "clicked-expand-section",
        "clicked-expand-table",
        "clicked-collapse-all-sections",
        "clicked-collapse-section",
        "clicked-collapse-table"
      ],
      "productLine": {
        "type": "string",
        "isOptional": true
      },
      "products": {
        "type": "array",
        "isOptional": true
      },
      "currentPlan": {
        "type": "string",
        "isOptional": true
      },
      "recommendedPlan": {
        "type": "string",
        "isOptional": true
      },
      "showRecommended": {
        "type": "boolean",
        "isOptional": true
      },
      "screen": "string",
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      },
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "communicationMethodsInteraction": {
    "name": "communication-methods-interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "chat-shown",
        "chat-conversation-started",
        "phone-element-shown",
        "phone-element-clicked"
      ],
      "phoneNumber": {
        "type": "string",
        "isOptional": true
      },
      "phoneSourceId": {
        "type": "string",
        "isOptional": true
      },
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "phoneNumberClick": {
    "name": "phone-number-click",
    "class": "interaction",
    "properties": {
      "phoneNumber": "string",
      "phoneSourceId": "string",
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "linkClick": {
    "name": "link-click",
    "class": "interaction",
    "properties": {
      "name": "string",
      "trackingSource": "string",
      "url": {
        "type": "string",
        "isOptional": true
      },
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "conversations": {
    "name": "conversations",
    "class": "interaction",
    "properties": {
      "action": [
        "conversation-started",
        "clicked-chat-with-sales"
      ],
      "formattedExperimentArray": {
        "type": "array",
        "isOptional": true
      },
      "conversationId": {
        "type": "number",
        "isOptional": true
      },
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "additional-units-picker": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "click"
      ],
      "value": [
        "stepper increase",
        "stepper decrease"
      ],
      "section": {
        "type": "string",
        "isOptional": true
      },
      "location": {
        "type": "string",
        "isOptional": true
      },
      "unitType": [
        "CONTACT",
        "MARKETING_CONTACT",
        "USER",
        "UNIT"
      ],
      "productLine": {
        "type": "string",
        "isOptional": true
      },
      "productLevel": {
        "type": "string",
        "isOptional": true
      },
      "productName": {
        "type": "string",
        "isOptional": true
      },
      "ownsProduct": {
        "type": "boolean",
        "isOptional": true
      },
      "skuId": "number",
      "ownedUnitQuantity": "number",
      "displayedUnitQuantity": "number",
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "clicked-link": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "click"
      ],
      "type": [
        "internal",
        "external"
      ],
      "url": "string",
      "location": {
        "type": "string",
        "isOptional": true
      },
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "modal-interaction": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "value": "string",
      "location": "string",
      "section": {
        "type": "string",
        "isOptional": true
      },
      "hub": {
        "type": "string",
        "isOptional": true
      },
      "feature": {
        "type": "string",
        "isOptional": true
      },
      "productLevel": {
        "type": "string",
        "isOptional": true
      },
      "ownedUnitQuantity": {
        "type": "number",
        "isOptional": true
      },
      "displayedUnitQuantity": {
        "type": "number",
        "isOptional": true
      },
      "additionalUnitQuantity": {
        "type": "number",
        "isOptional": true
      },
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "legacySidegradeConfirmationButton": {
    "name": "legacy-sidegrade-confirmation-button",
    "class": "interaction",
    "properties": {
      "action": [
        "clicked",
        "viewed"
      ],
      "productName": "string",
      "trackingSource": "string",
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "confirmContactsRedirectButtonInteraction": {
    "name": "confirm-contacts-redirect-button",
    "class": "interaction",
    "properties": {
      "action": "string",
      "trackingSource": "string",
      "isSidegrade": {
        "type": "boolean",
        "isOptional": true
      },
      "productNames": {
        "type": "array",
        "isOptional": true
      },
      "skuIds": {
        "type": "array",
        "isOptional": true
      },
      "additionalUnitQuantity": {
        "type": "number",
        "isOptional": true
      },
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "buyAdditionalContacts": {
    "name": "buy-additional-contacts",
    "class": "interaction",
    "properties": {
      "trackingSource": "string",
      "productNames": "array",
      "skuIds": "array",
      "additionalUnitQuantity": {
        "type": "number",
        "isOptional": true
      },
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "proCompareToolInteraction": {
    "name": "pro-compare-tool-interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "productLevel": {
        "type": "string",
        "isOptional": true
      },
      "productLine": {
        "type": "string",
        "isOptional": true
      },
      "domain": {
        "type": "string",
        "isOptional": true
      },
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "limitUsageView": {
    "name": "limit-usage-view",
    "class": "view",
    "properties": {
      "screen": "string",
      "hasUsageOnLimits": {
        "type": "boolean"
      },
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "buyClick": {
    "name": "buy-click",
    "class": "interaction",
    "properties": {
      "sourceId": {
        "type": "string"
      },
      "productNames": "array",
      "skuIds": "array",
      "nonMerchandiseIdProduct": {
        "type": [
          "growthstarter",
          "growthstarter-covid"
        ],
        "isOptional": true
      },
      "hubsSignupUrl": {
        "type": "string"
      },
      "hubsSignupCta": {
        "type": "string"
      },
      "upgradeProduct": {
        "type": "string"
      },
      "bundledOffer": {
        "type": "string",
        "isOptional": true
      },
      "merchandiseId": {
        "type": "string",
        "isOptional": true
      },
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "signupClick": {
    "name": "signup-click",
    "class": "interaction",
    "properties": {
      "sourceId": {
        "type": "string"
      },
      "signupType": {
        "type": [
          "crm",
          "marketing",
          "sales",
          "service"
        ]
      },
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  },
  "talkToSales": {
    "name": "talk-to-sales-click",
    "class": "interaction",
    "properties": {
      "sourceId": {
        "type": "string"
      },
      "productName": "string",
      "skuId": "number",
      "nonMerchandiseIdProduct": {
        "type": [
          "growthstarter",
          "growthprofessional",
          "growthenterprise",
          "bundle",
          "marketingstartercms",
          "growthstarter-covid"
        ],
        "isOptional": true
      },
      "hubsSignupUrl": {
        "type": "string"
      },
      "hubsSignupCta": {
        "type": "string"
      },
      "upgradeProduct": {
        "type": "string"
      },
      "wordpressPlugin": {
        "type": "string",
        "isOptional": true
      },
      "activeCurrencyCode": {
        "type": "string",
        "isOptional": true
      },
      "defaultedTab": {
        "type": "string",
        "isOptional": true
      },
      "countryTerritory": {
        "type": "string",
        "isOptional": true
      },
      "isRetail": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      },
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "tab": {
        "type": [
          "starter",
          "enterprise"
        ],
        "isOptional": true
      },
      "isSeatsPilot": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "pricing-pages-ui"
  }
};